export const DeviceType = Object.freeze({
  IOS: "iOS",
  ANDROID: "Android",
  WEB: "Web",
});

export const SourceType = Object.freeze({
  FACEBOOK: "Facebook",
  INSTAGRAM: "Instagram",
  OTHER: "Other",
});
